import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO. Pass title/description/path; falls back to sane defaults.
 */
export const Seo = ({
    title,
    description,
    path = "/",
    image = "https://customer-assets.emergentagent.com/job_portfolio-live-55/artifacts/4oo43pid_Screenshot%202022-06-02%20at%2013.55%201%201.png",
    type = "website",
    lang = "en",
    structuredData = null,
}) => {
    const url = `https://charlyndewulf.be${path}`;
    const fullTitle = title
        ? `${title} · Charlyn De Wulf`
        : "Charlyn De Wulf — UX Designer & Strategist · Portfolio";
    const desc =
        description ||
        "Charlyn De Wulf is a UX designer and strategist based in Belgium. Enterprise UX, design systems and research-led product design.";

    return (
        <Helmet>
            <html lang={lang} />
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />

            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={image} />

            {structuredData && (
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    );
};
